import { render, staticRenderFns } from "./botaoSuperior.vue?vue&type=template&id=cbc6ced0&scoped=true"
import script from "./botaoSuperior.vue?vue&type=script&lang=js"
export * from "./botaoSuperior.vue?vue&type=script&lang=js"
import style0 from "./botaoSuperior.vue?vue&type=style&index=0&id=cbc6ced0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc6ced0",
  null
  
)

export default component.exports